// extracted by mini-css-extract-plugin
export default {"message_box":"MessageBoxSimple_message_box__+UikP","message":"MessageBoxSimple_message__2LA96"};